import { apiGateway } from "@/shared/apiGateway";

const getQuoteListing = (
  context,
  { clientId, contractorRegionId, filterCriteria, searchCriteria }
) => {
  var url = "api/quotes";
  url = url + "?pageNo=" + searchCriteria.currentPage;
  url = url + "&itemsPerPage=" + searchCriteria.itemsPerPage;
  if (searchCriteria.searchText != undefined) {
    url = url + "&searchText=" + searchCriteria.searchText;
  }
  if (clientId !== undefined) {
    url = url + "&clientId=" + clientId;
  }
  if (contractorRegionId !== undefined) {
    url = url + "&contractorRegionId=" + contractorRegionId;
  }
  if (filterCriteria.quoteTypeId !== 0) {
    url = url + "&quoteType=" + filterCriteria.quoteTypeId;
  }
  if (filterCriteria.plantState === 2) {
    url = url + "&plantState=" + filterCriteria.plantState;
  }
  if (
    filterCriteria.quoteStatusId !== 0 &&
    filterCriteria.quoteStatusId !== undefined
  ) {
    url = url + "&quoteStatus=" + filterCriteria.quoteStatusId;
  } else {
    url = url + "&quoteGroup=" + filterCriteria.quoteGroup;
  }
  if (filterCriteria.quotePriorityId > 0) {
    url = url + "&quotePriority=" + filterCriteria.quotePriorityId;
  }

  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      return context.commit("Set_Quotes", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Quotes"], {
        root: true
      });
    });
};

const getQuoteDetail = (context, quoteId) => {
  return apiGateway
    .apiGatewayGET("api/quotes/" + quoteId)
    .then(data => {
      context.commit("Set_Quote", data);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Quote"], {
        root: true
      });
    });
};

const createQuote = (commit, { quote }) => {
  return apiGateway.apiGatewayPOST("api/quotes?", quote).then(data => {
    return data;
  });
};

const reissueQuote = (commit, { form }) => {
  return apiGateway.apiGatewayPOST("api/quotes/reissue", form).then(data => {
    return data;
  });
};

const updateQuote = (commit, { form }) => {
  return apiGateway.apiGatewayPUT("api/quotes/", form).then(data => {
    return data;
  });
};

const updateQuoteStatus = (commit, quoteStatus) => {
  quoteStatus.noteType = 1;
  return apiGateway
    .apiGatewayPATCH("api/quotes/update-quote-status/", quoteStatus)
    .then(data => {
      return data;
    });
};

const createQuoteNote = (commit, body) => {
  body.noteType = 1;
  return apiGateway.apiGatewayPATCH("api/quotes/update-quote-notes", body);
};

const searchPlant = (context, { searchCriteria }) => {
  var url = "api/quotes/search-plant";
  if (searchCriteria.searchText != undefined) {
    url = url + "?searchText=" + searchCriteria.searchText;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error searching for plant"], {
        root: true
      });
    });
};

export default {
  getQuoteListing,
  getQuoteDetail,
  createQuote,
  updateQuoteStatus,
  updateQuote,
  createQuoteNote,
  reissueQuote,
  searchPlant
};
